<template>
  <div class="detail-container">
    <h1 class="page-title">顧客担当者マスタ情報詳細</h1>
    <div v-if="customer_representative">
      <div v-if="customer_representative.m_customer">
        <table class="table table-bordered">
          <tr>
            <th>ID</th>
            <td>{{ customer_representative.id }}</td>
          </tr>
          <tr>
            <th>顧客名</th>
            <td>{{ customer_representative.m_customer.customer_nm }}</td>
          </tr>
          <tr>
            <th>担当者部署</th>
            <td>{{ customer_representative.in_charge_department_nm }}</td>
          </tr>
          <tr>
            <th>担当者名(姓)</th>
            <td>{{ customer_representative.in_charge_last_nm }}</td>
          </tr>
          <tr>
            <th>担当者名(名)</th>
            <td>{{ customer_representative.in_charge_first_nm }}</td>
          </tr>
          <tr>
            <th>担当者メールアドレス</th>
            <td>{{ customer_representative.in_charge_email }}</td>
          </tr>
          <tr>
            <th>予定表送付先宛名で使用</th>
            <td><span v-if="customer_representative.cal_destination_address_use_flg">◯</span></td>
          </tr>
          <tr>
            <th>請求書送付先宛名で使用</th>
            <td><span v-if="customer_representative.bill_destination_address_use_flg">◯</span></td>
          </tr>
        </table>

        <div class="btn-area">
          <router-link :to="{ name: 'CustomerRepresentativeList', params: { id: customer_representative.id }, query: route.query }"> <!-- 顧客情報編集ページへのリンク -->
            <button type="button" class="btn btn-primary">一覧へ</button>
          </router-link>

          <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'CustomerRepresentativeEdit', params: { id: customer_representative.id }, query: route.query }"> <!-- 顧客情報編集ページへのリンク -->
            <button type="button" class="btn btn-success mx-2">編集</button>
          </router-link>
        </div>
      </div>
      <div v-else>
        顧客情報情報を読み込み中...
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      顧客担当者情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getCustomerRepresentative } from '@/api/axios';

export default {
  setup() {
    const title = ref('顧客担当者情報詳細');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const customer_representative = ref({});
    const customer_representativeId = route.params.id;

    const fetchCustomerRepresentative = async () => {
      const response = await getCustomerRepresentative(customer_representativeId);
      customer_representative.value = response.data;
    };

    onMounted(fetchCustomerRepresentative);

    return {
      title,
      userRole,
      customer_representative,
      route
    };
  }
};
</script>
